<template>
  <slot />
</template>

<script lang="ts" setup>
import { provide, reactive } from 'vue';
import { headerKey, type HeaderProvider } from './injects';

const header = reactive<HeaderProvider>({
  extraBreadcrumbs: [],
  title: [],
  globalFilterComponent: [],
});

provide(headerKey, header);
</script>

<style lang="scss" scoped>
</style>
